import React from 'react';
import { Icon } from 'elements';

const Instagram = ({size, className}) => (
  <Icon size={size} className={className}>
    <path d="M17.281,0H6.587C2.955,0,0.001,2.955,0.001,6.587v10.694c0,3.632,2.955,6.587,6.586,6.587h10.694
      c3.632,0,6.587-2.955,6.587-6.587V6.587C23.868,2.955,20.913,0,17.281,0z M21.75,17.281c0,2.464-2.005,4.469-4.469,4.469H6.586
      c-2.464,0-4.469-2.005-4.469-4.469V6.587c0-2.464,2.005-4.469,4.469-4.469H17.28c2.464,0,4.469,2.005,4.469,4.469L21.75,17.281
      L21.75,17.281z"/>
    <path d="M11.934,5.784c-3.391,0-6.15,2.759-6.15,6.15c0,3.391,2.759,6.15,6.15,6.15s6.15-2.759,6.15-6.15
      C18.084,8.543,15.325,5.784,11.934,5.784z M11.934,15.966c-2.223,0-4.032-1.809-4.032-4.032c0-2.224,1.809-4.032,4.032-4.032
      c2.224,0,4.032,1.809,4.032,4.032S14.157,15.966,11.934,15.966z"/>
    <path d="M18.342,3.988c-0.408,0-0.809,0.165-1.097,0.455c-0.29,0.288-0.456,0.689-0.456,1.098
      c0,0.408,0.167,0.809,0.456,1.098c0.288,0.288,0.689,0.455,1.097,0.455c0.409,0,0.809-0.167,1.098-0.455
      c0.289-0.289,0.455-0.69,0.455-1.098c0-0.409-0.165-0.81-0.455-1.098C19.152,4.154,18.751,3.988,18.342,3.988z"/>
  </Icon>
);

export default Instagram;



// WEBPACK FOOTER //
// ./src/core/icons/components/social/Instagram.jsx